import { IconProps, iconA11yProps } from '../types';

export const Close = ({ classNames, label }: IconProps) => (
    <svg className={`${classNames}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...iconA11yProps(label)}>
        <path d="M19 5l-14 14" />
        <path d="M5 5l14 14" />
    </svg>
);
